import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';
import { UserSessionService } from '../../services/user.session.service';
import { loadApplications, loadApplicationTemplates } from 'src/app/admin/container/application/store/application.actions';
import { getApplications, getApplicationTemplates } from 'src/app/admin/container/application/store/application.selectors';
import { ApplicationService } from '../../services/application.service';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { IAppState } from 'src/app/store/index.state';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  @Input() modalType: any;
  @Input() isAdmin: any;
  @Input() shareItem: any;
  @Input() selectedApplication: any;
  @Input() deleteSelectedDevice: any;
  @Input() deleteSelectedLab: any;
  @Input() org_type: string = "";
  applicationType: boolean = false;
  @Output() emitCloseEvent = new EventEmitter();
  @Output() emitDeleteAction = new EventEmitter();
  publishForm: FormGroup;
  isLoading: boolean = false;
  applicationName:string;
  applicationIdentifier:string;
  // dropdownOptions: string[] = ['GROK', 'SCHOOL', 'COLLEGE', 'INDUSTRY'];
  // dropdownPublish: string[] = ['Internally', 'Externally'];
  getTemplate : any;
  application_identifier:string;





  applications$ = this.store.select(getApplications);
  applicationTemplates$ = this.store.select(getApplicationTemplates);
  isExternallyCheckBoxVisible: boolean = false;


  constructor(
    private sessionStorageService: SessionStorageService,
    private userSessionService: UserSessionService,
    private store: Store<IAppState>,
    private appService:ApplicationService,
    private toasterService:ToastrService,
    private fb:FormBuilder,
    private applicationService: ApplicationService
  ) { 
    this.publishForm = this.fb.group({
      applicationidentifier: [''],
      applicationType: [''],
      publish_id: [''],
      grok: [false],
      school: [false],
      college: [false],
      industry: [false],
      externally: [false]
    });
  }

  async ngOnInit() {
    console.log("selected lab", this.deleteSelectedLab)
    this.isLoading = true;
    if(!window.location.href.includes('nielit')){
      await this.userSessionService.extendToken(this.sessionStorageService.getUsername()).toPromise();
      if(this.shareItem){
        this.getTemplate  = await this.appService.getTemplatePublish(this.shareItem?.applicationIdentifier).toPromise();
      this.isLoading = false;
      this.applicationName = this.getTemplate?.applicationName
      this.applicationIdentifier = this.getTemplate?.application_identifier
      
    // if (this.getTemplate.isPublishedInternally) {
    //   this.publishform.controls['publish_id'].setValue('Internally');
    // } else if (this.getTemplate .isPublishedExternally) {
    //   this.publishform.controls['publish_id'].setValue('Externally');
    // } else {
    //   this.publishform.controls['publish_id'].setValue('');
    // }

      const toArray = this.getTemplate?.applicationType.split(',').map((value :any) => value.trim());  
      this.isExternallyCheckBoxVisible = toArray.length === 1 && toArray.includes("GROK") ? true : false
      
    // if (this.getTemplate.applicationType) {
    //   this.publishform.controls['applicationType'].setValue(this.getTemplate.applicationType.toUpperCase());
    // } else {
    //   this.publishform.controls['applicationType'].setValue('');
    // }

      if(this.getTemplate?.isPublishedExternally && this.isExternallyCheckBoxVisible){
        this.publishForm.get('externally').setValue(this.getTemplate?.isPublishedExternally);
      }
      if(this.getTemplate?.applicationType){
        const applicationTypes = this.getTemplate?.applicationType.split(',').map((value :any) => value.trim());
        
        Object.keys(this.publishForm.value).forEach(key => {
          if(key !== 'externally') {
            this.publishForm.get(key)?.setValue(applicationTypes.includes(key.toUpperCase()))
          }
        })
      }
    }
      this.application_identifier = this.applicationIdentifier;
    }
  }

  // onFocus() {
  //   this.applicationType = false
  // }

  onCheckBoxChange(){
    const grokChecked = this.publishForm.get('grok')?.value;
    const schoolChecked = this.publishForm.get('school')?.value;
    const collegeChecked = this.publishForm.get('college')?.value;
    const industryChecked = this.publishForm.get('industry')?.value;

    this.isExternallyCheckBoxVisible = grokChecked && (!schoolChecked && !collegeChecked && !industryChecked) ? true : false;
    if(grokChecked && this.getTemplate.isPublishedExternally){
      this.publishForm.get('externally').setValue(this.getTemplate.isPublishedExternally)
    }
  }

  async updatePublish() {
    const selectedValue = Object.keys(this.publishForm.value).filter(key => key !== 'externally' && this.publishForm.value[key] === true);
    this.isLoading = true
    // if (!this.publishform.get('applicationType')?.value && this.publishform.get('publish_id')?.value) {
    //   console.log(this.publishform.get('publish_id')?.value);
    //   this.applicationType = true
    //   this.isLoading = false;
    //   return;
    // }
    // const controls = this.publishform.controls;
    
    let isInternally = false;
    let isExternally = false;

    if (selectedValue.length > 0) {
      isExternally = true;
      if (selectedValue.length === 1 && selectedValue.includes('grok')) {
        isExternally = this.publishForm.get('externally').value;
        isInternally = !isExternally;
      }
    }
    const payload = {
      applicationType: selectedValue,
      isPublishedInternally: isInternally,
      isPublishedExternally: isExternally,
      userName: this.sessionStorageService.getUsername()
    };
    
    try {
      const result: any = await this.appService.updatepublish(payload, this.applicationIdentifier).toPromise();
      if (result) {
        this.toasterService.success("Application updated successfully");
        this.emitCloseEvent.emit(false);
        this.store.dispatch(loadApplicationTemplates());
      }

    } catch (err: any) {
      console.log(err.error.message);
      this.toasterService.error(`${err.error.message}`);
    }
  }

  isUnpublish(): boolean {
    return !this.publishForm.get('publish_id')?.value;
  }

  // changeInternallyPublishedFlag(): void {
  //   if (this.selectedApplication) {
  //     console.log(this.selectedApplication);
      
  //     const updatedApplication = { ...this.selectedApplication };
  //     updatedApplication.is_published = true;
  //     updatedApplication.isInternallyPublished = true;
    
        
  //     console.log('Update Payload:', updatedApplication);
  //     console.log('Application Identifier:', updatedApplication.applicationIdentifier);
  
  //     this.applicationService.updateApplicationTemp(updatedApplication, updatedApplication.applicationIdentifier)
  //       .subscribe(
  //         (response) => { 
  //           console.log('Application updated successfully:', response);
  //           this.emitCloseEvent.emit(false);
  //           this.store.dispatch(loadApplicationTemplates());
  //         },
  //         (error) => {
  //           console.error('Failed to update application:', error);
  //           console.log('Error response:', error);
  //         }
  //       );
  //   }
  // }

  // changePublishedFlag(): void {

  //   if (this.selectedApplication) {
  //     console.log(this.selectedApplication);
      
  //     const updatedApplication = { ...this.selectedApplication };
  //     updatedApplication.is_published = true;
  //     updatedApplication.isInternallyPublished = false;
        
  //     console.log('Update Payload:', updatedApplication);
  //     console.log('Application Identifier:', updatedApplication.applicationIdentifier);
  
  //     this.applicationService.updateApplicationTemp(updatedApplication, updatedApplication.applicationIdentifier)
  //       .subscribe(
  //         (response) => { 
  //           console.log('Application updated successfully:', response);
  //           this.emitCloseEvent.emit(false);
  //           this.store.dispatch(loadApplicationTemplates());
  //         },
  //         (error) => {
  //           console.error('Failed to update application:', error);
  //           console.log('Error response:', error);
  //         }
  //       );
  //   }
  // }


  closeModal(modalType: string) {
    document.getElementById(modalType).style.display = 'none';
    this.emitCloseEvent.emit(false);
  }
  deleteData(event: any) {
    this.emitDeleteAction.emit(true);
  }
}
